import { Table3DataContext } from '~/app/shared/table3tools/contexts/Table3DataContext';
import useDefaultFilterParamFactory from '~/app/shared/table3tools/hooks/useDefaultFilterParamFactory';
import usePaginatedDataFetcher from '~/app/shared/table3tools/hooks/usePaginatedDataFetcher';
import useTable3DataContextLoader from '~/app/shared/table3tools/hooks/useTable3DataContextLoader';
import { FilterParamFactory } from '~/app/shared/table3tools/types';
import { ProductCollectionListViewModel } from '~/types/internal-api';

export default function useProductCollectionTable3DataContextLoader(): Table3DataContext<ProductCollectionListViewModel> {
    const paramFactory: FilterParamFactory = useDefaultFilterParamFactory();
    const endpoint = `/products/product-collections`;
    const fetcher = usePaginatedDataFetcher<ProductCollectionListViewModel>(endpoint, paramFactory);
    return useTable3DataContextLoader(fetcher);
}
